import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadSidePanelFeed } from 'redux/modules/side-panel-feed';

class SidePanel extends React.Component {
  componentDidMount() {
    this.props.loadSidePanelFeed();
  }

  render() {
    const { items, defaultItems, error } = this.props;
    return (
      <div>
        {!error && items.length ? (
          items.map((item, key) => {
            return (
              <li key={key}>
                <a href={item.link} target="_blank">
                  {item.label}
                </a>
              </li>
            );
          })
        ) : (
          <div dangerouslySetInnerHTML={{ __html: defaultItems }} />
        )}
      </div>
    );
  }
}

SidePanel.propTypes = {
  items: PropTypes.array.isRequired,
  defaultItems: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  loadSidePanelFeed: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  items: state.sidePanelFeed.items,
  error: state.sidePanelFeed.error,
});

const mapDispatchToProps = dispatch => ({
  loadSidePanelFeed: () => dispatch(loadSidePanelFeed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidePanel);
